import { ChartConfig } from 'components/Charts/types';

/**
 * Shared line chart configuration for amount-based charts
 * (Unrealized Value and Invested Capital)
 */
export const getLineChartConfig = (): ChartConfig => ({
  title: '',
  xAxis: { label: 'Date' },
  yAxis: { label: 'Amount ($)' },
  legend: { show: true, position: 'top' },
  tooltip: { show: true },
  options: {
    animation: true,
    animationDuration: 2000,
    animationEasing: 'cubicOut',
    animationDelay: (idx: number) => idx * 100,
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
        lineStyle: {
          color: '#6a7985',
          width: 1,
          type: 'dashed',
        },
      },
      backgroundColor: 'rgba(50, 50, 93, 0.95)',
      borderColor: 'rgba(255, 255, 255, 0.1)',
      borderWidth: 1,
      textStyle: {
        color: '#fff',
        fontSize: 12,
      },
      padding: [10, 15],
      formatter: (params: any) => {
        const param = Array.isArray(params) ? params[0] : params;
        return `
          <div style="font-weight: 600; margin-bottom: 5px;">${param.name}</div>
          <div style="display: flex; align-items: center; gap: 8px;">
            <span style="display: inline-block; width: 10px; height: 10px; background: ${param.color}; border-radius: 50%;"></span>
            <span>${param.seriesName}: <strong style="color: ${param.color};">$${param.value?.toLocaleString() || 0}</strong></span>
          </div>
        `;
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '8%',
      top: '15%',
      containLabel: true,
    },
  },
});
